import React from 'react';
import { BaseResourceListProps, SimpleList, SvgBin, SvgEdit } from '@app/components';
import { accountCodeApi } from '@app/store';
import { IAccountCode } from '@app/common';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<IAccountCode>();

export const AccountCodeList = ({ onUpdate, onDelete, onRowPress, selectedRowItem }: BaseResourceListProps<IAccountCode>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <SimpleList.HeaderItem width="75%">
          <SimpleList.HeaderItemLabel>Nom</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="75%">
          <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
            {info.getValue()}
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align='center'>
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          <SimpleList.ItemActions>
            <CheckPermissions permissions={['dashboard::account-codes.update']}>
              <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>

            <CheckPermissions permissions={['dashboard::account-codes.delete']}>
              <SimpleList.ItemAction onPress={() => onDelete(row.original)}>
                <SvgBin color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>
          </SimpleList.ItemActions>
        </SimpleList.ItemCol >
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) => accountCodeApi.useReadManyAccountCodesQuery({
      pagination,
      filters: {
        name: {
          $contains: search
        }
      },
      sort: ['name:ASC']
    })
  });

  return <SimpleList
    table={table}
    isFetching={isFetching}
    onSearch={setSearch}
    selectedRowItem={selectedRowItem}
    onRowPress={onRowPress} />;
};
